import { axiosInstance, requestConfig } from 'network/apis';

import { URL_GAME, URL_SYSTEM } from 'utils/constants';

export const callShopTournamentRawData = async (tournamentId) => {
    const handlerEnabled = true;

    return await axiosInstance(requestConfig('get', URL_GAME, `/tournament/${tournamentId}/raw-data`), { handlerEnabled });
};

export const callShopTournamentTerms = async (lang) => {
    return await axiosInstance(requestConfig('get', URL_SYSTEM, `/system-setting/${lang}/ShopTournamentTerms?isfrontview=true&isuse=true`));
};

export const callShopTournamentCourseList = async () => {
    const isAuthorization = false;

    return await axiosInstance(requestConfig('get', URL_SYSTEM, `/course`, null, {}, false, false), { isAuthorization });
};

export const callShopTournamentCourseDetails = async (courseId) => {
    const isAuthorization = false;

    return await axiosInstance(requestConfig('get', URL_SYSTEM, `/course/${courseId}`, null, {}, false, false), { isAuthorization });
};

export const callAddTournament = async (data) => {
    return await axiosInstance(requestConfig('post', URL_GAME, `/tournament`, data));
};

export const callModifyTournament = async (tournamentId, data) => {
    return await axiosInstance(requestConfig('put', URL_GAME, `/tournament/${tournamentId}`, data));
};
